import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "@/styles/globals.css";
import { BrowserRouter } from "react-router-dom";
import store from "./app/store.ts";
import { Provider } from "react-redux";
import { Toaster } from "@/components/ui/Toaster.tsx";
import { TooltipProvider } from "./components/ui/ToolTip.tsx";

// In your main application code where you register the service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    if (registrations.length === 0) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js',{
        scope: '/'
      })
        .then((registration) => {
          // console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch((error) => {
          // console.error('Service Worker registration failed:', error);
        });
    } else {
      // console.log('Service Worker already registered.');
    }
  });
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <TooltipProvider>
          <App />
        </TooltipProvider>
        <Toaster />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

